import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import images from '../../../Utils/images';
import colors from '../../../Utils/colors';
import CheerioButton from '../../../Components/CheerioButton';
import { saveInstagramToken } from '../../../Services';

const SetupInstagram = () => {
  const localdata = useSelector((state) => state.main.localdata);
  const authtoken = useSelector((state) => state.main.auth_token);
  const navigate = useNavigate();

  return (
    <>
      <div className="setup_container">
        <div className="setup_container__left verythinscrollnewinv">
          <div>
            <div className="setup_container__left__header">
              <img
                src={images.BackArrowBlack}
                style={{ height: 20, width: 20, objectFit: 'contain', cursor: 'pointer' }}
                onClick={() => {
                  navigate(-1);
                }}
              />
              <h3>{'Instagram on Omnybox'}</h3>
            </div>

            <h4>{`What you’ll need`}</h4>
            <h4>{`Pre-installation`}</h4>
            <p>{`To connect Instagram on Omnybox. You will require a Facebook Business Account, Facebook Business Page, and Connected Instagram Account.`}</p>
            <h4>{`What can I do with Instagram on Omnybox?`}</h4>
            <p>
              {`1. Automate your incoming story replies with messages, carousel cards, links to increase conversion`}
              <br />
              {`2. Automate comment replies to keep the engagement going`}
              <br />
              {`3. Send and receive messages from your followers directly on Omnybox`}
              <br />
              {`4. Send payment or product links when people comments on your post or a reel`}
              <br />
              {`5. Run Click-to-DM Ads to increase conversion and engagement of your business`}
              <br />
            </p>
            <h4>{`Channel Capabilities`}</h4>
            <p>
              {`1. Text`}
              <br />
              {`2. Image`}
              <br />
              {`3. Videos`}
              <br />
              {`4. Links`}
              <br />
              {`5. Button`}
              <br />
              {`6. Carousel Cards`}
              <br />
              {`7. Product Cards`}
            </p>
          </div>
        </div>
        <div className="setup_container__right">
          <div className="setup_modal">
            <h3 className="my-2">{'Connect Instagram'}</h3>
            <p className="w-100 my-3" style={{ color: colors.greys04 }}>
              {'To continue, You need to connect your Instagram Account with Omnybox for further setup.'}
            </p>
            <h4 className="my-2" style={{ fontWeight: 600 }}>
              {'Pre-requisites'}
            </h4>
            <p className="my-3">
              {`1. An Instagram Business account.`}
              <br />
              {`2. Facebook page with admin access.`}
              <br />
              {`3. Messaging permissions enabled in Instagram.`}
              <br />
              {`4. Associated Instagram business account with Facebook Business page.`}
            </p>
            <CheerioButton
              btnText={'Continue with Facebook'}
              textStyle={{ color: colors.white01 }}
              backColor={colors.primary03}
              borderStyle={{ width: '100%', marginBlock: '20px', borderColor: colors.primary03 }}
              onclick={() => {
                if (localdata?.metaConfig?.instagramPageName && localdata?.metaConfig?.instagramPageName !== '') {
                  navigate('/creator/instagramReplies');
                } else {
                  window.FB.login(
                    function (response) {
                      console.log({
                        response,
                      });
                      console.log('WAITING FOR INSTAGRAM TOKEN');
                      if (response.authResponse) {
                        let token = authtoken;
                        console.log('RECEIVED INSTAGRAM TOKEN', response.authResponse);
                        const fbToken = response.authResponse.accessToken;
                        saveInstagramToken(token, { token: fbToken })
                          .then((res) => {
                            console.log('SAVED INSTAGRAM TOKEN');
                            if (res?.flag) {
                              toast.success('Instagram connected successfully!', { autoClose: 2000, position: 'top-right' });
                              setTimeout(() => {
                                navigate('/creator');
                              }, 2000);
                            } else {
                              toast.error(res?.message, { position: 'top-center' });
                            }
                          })
                          .catch((e) => {
                            console.log(e.message);
                          });
                      } else {
                        console.log('User cancelled login or did not fully authorize.');
                      }
                    },
                    {
                      scope:
                        'pages_show_list,business_management,pages_messaging,instagram_basic,instagram_manage_messages,pages_manage_metadata,pages_read_engagement,instagram_manage_comments,instagram_manage_insights,catalog_management,instagram_content_publish',
                    }
                  );
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SetupInstagram;
